import { DataSchemaItemFragment } from 'generated/resources/graphql'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

interface Props {
  dataSchemaItem?: DataSchemaItemFragment
  values: string[]
  onChange: (teamIds: string[]) => void
  mandatory?: boolean
  error?: string
  legalEntityId?: number
}

export const MultiTeamField = ({
  dataSchemaItem,
  values,
  onChange,
  mandatory,
  error,
  legalEntityId,
}: Props) => {
  if (!dataSchemaItem) {
    return null
  }

  let allowedValues = dataSchemaItem.allowedValues ?? []
  if (legalEntityId) {
    allowedValues = allowedValues.filter(
      (option) => !option.legalEntityIds || option.legalEntityIds?.includes(legalEntityId)
    )
  }

  if (!allowedValues.length) return null

  const handleChange = (newValues: unknown) => {
    if (Array.isArray(newValues)) {
      onChange(newValues.map(String))
    } else if (newValues) {
      onChange([String(newValues)])
    } else {
      onChange([])
    }
  }

  return (
    <Selector.Popover
      blankLabel={i18n.t('employee_form.payroll_data.select_an_option')}
      placeholder={i18n.t('employee_form.payroll_data.select_an_option')}
      searchPlaceholder={dataSchemaItem.label}
      inputStyle="badge"
      label={dataSchemaItem.label}
      onChange={handleChange}
      value={values}
      isMultiSelect
      mandatory={mandatory}
      error={error}
    >
      {allowedValues.map((allowedValue) => (
        <Selector.Option
          key={allowedValue.key}
          value={allowedValue.key}
          label={allowedValue.value}
          searchValue={allowedValue.value}
        >
          {allowedValue.value}
        </Selector.Option>
      ))}
    </Selector.Popover>
  )
}
